import React from 'react';
import { Button } from '@mui/material';
import ThemeEditorDialog from '../dialogs/ThemeEditorDialog';
import i18n from '../../i18';
import { convertColorToRGBA } from '../../utils/formatGradient';

export default class DialogThemeField extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        };
    }
    getParsedValue(value) {
        try {
            return JSON.parse(value);
        } catch (e) {
            return null;
        }
    }
    render() {
        const value = this.getParsedValue(this.props.value);
        const gradientColorsPrivate = value?.gradientColorsPrivate || [];
        const gradientColorsShop = value?.gradientColorsShop || [];
        const gradientColorsAction = value?.gradientColorsAction || [];
        const colorPrivate = value?.colorPrivate;
        const colorShop = value?.colorShop;
        const colorAction = value?.colorAction;
        const required = this.props.field.required;
        const requiredLabel = required ? ' *' : '';
        return (
            <>
                <Button
                    variant="text"
                    onClick={() => {
                        this.setState({ open: true });
                    }}
                >
                    {value ? (
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}
                        >
                            {i18n.t('themeEditor.theme')}: &nbsp;
                            {gradientColorsPrivate.length > 0 && (
                                <div
                                    style={{
                                        width: '40px',
                                        height: '40px',
                                        borderRadius: '50%',
                                        background: `linear-gradient(to right, ${gradientColorsPrivate
                                            .map((color) =>
                                                convertColorToRGBA(color)
                                            )
                                            .join(',')})`
                                    }}
                                ></div>
                            )}
                            {colorPrivate && (
                                <div
                                    style={{
                                        width: '40px',
                                        height: '40px',
                                        borderRadius: '50%',
                                        background:
                                            convertColorToRGBA(colorPrivate)
                                    }}
                                ></div>
                            )}
                            {gradientColorsShop.length > 0 && (
                                <div
                                    style={{
                                        width: '40px',
                                        height: '40px',
                                        borderRadius: '50%',
                                        background: `linear-gradient(to right, ${gradientColorsShop
                                            .map((color) =>
                                                convertColorToRGBA(color)
                                            )
                                            .join(',')})`
                                    }}
                                ></div>
                            )}
                            {colorShop && (
                                <div
                                    style={{
                                        width: '40px',
                                        height: '40px',
                                        borderRadius: '50%',
                                        background:
                                            convertColorToRGBA(colorShop)
                                    }}
                                ></div>
                            )}
                            {gradientColorsAction.length > 0 && (
                                <div
                                    style={{
                                        width: '40px',
                                        height: '40px',
                                        borderRadius: '50%',
                                        background: `linear-gradient(to right, ${gradientColorsAction
                                            .map((color) =>
                                                convertColorToRGBA(color)
                                            )
                                            .join(',')})`
                                    }}
                                ></div>
                            )}
                            {colorAction && (
                                <div
                                    style={{
                                        width: '40px',
                                        height: '40px',
                                        borderRadius: '50%',
                                        background:
                                            convertColorToRGBA(colorAction)
                                    }}
                                ></div>
                            )}
                        </div>
                    ) : (
                        i18n.t('themeEditor.chooseTheme') + requiredLabel
                    )}
                </Button>
                <ThemeEditorDialog
                    dialogOpen={this.state.open}
                    onSave={(theme) =>
                        this.props.onChange(this.props.field.id, theme)
                    }
                    onClose={() => this.setState({ open: false })}
                    initialValue={value}
                />
            </>
        );
    }
}
